import qs from 'query-string';
import { apiConfig } from '@/services/api-config';

export const updateStatusTerritoryOfficial = async (cdTerritory: string, status: string) => {
  const userLogged = JSON.parse(sessionStorage.getItem('userLogged') as string);
  const { stKey } = userLogged.company;

  const query = qs.stringify({ tokenKey: stKey, cdTerritory, status });

  return apiConfig
    .put(`api/Territory/update-status-official?${query}`)
    .then((response) => {
      const { objectResult } = response.data;

      return objectResult;
    })
    .catch(() => []);
};
